import React, { memo } from 'react';
import {
	useAdjustmentsEnabled,
	isFieldTypeSupported,
} from '@atlassian/ui-modifications-core/controllers';
import { getNormalizedType } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/utils/get-normalized-field-type/index.tsx';
import { GIC_VIEW_TYPE } from '../../common/constants/index.tsx';
import { EnabledFieldValueDecorator } from './enable-field-value-decorator/index.tsx';
import type { EnabledFieldValueDecoratorProps } from './enable-field-value-decorator/types.tsx';

export type FieldValueDecoratorProps = EnabledFieldValueDecoratorProps<unknown, string | undefined>;

const FieldValueDecoratorAsyncNoMemo = ({
	children,
	fieldType,
	gqlType,
	fieldProps,
	fieldId,
}: FieldValueDecoratorProps): React.JSX.Element => {
	const adjustmentsAreEnabled = useAdjustmentsEnabled();

	const undecoratedResult = children(fieldProps);

	const normalizedType = getNormalizedType(fieldType, gqlType);

	if (isFieldTypeSupported(GIC_VIEW_TYPE, normalizedType) && adjustmentsAreEnabled) {
		return (
			<EnabledFieldValueDecorator
				fieldProps={fieldProps}
				fieldId={fieldId}
				fieldType={normalizedType}
			>
				{children}
			</EnabledFieldValueDecorator>
		);
	}

	return undecoratedResult;
};

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const FieldValueDecoratorAsync = memo(
	FieldValueDecoratorAsyncNoMemo,
) as typeof FieldValueDecoratorAsyncNoMemo;
